export enum DelayType {
  DURATION = 'duration',
  WAIT_UNTIL = 'wait_until',
}
